"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBCTABlock", {
  enumerable: true,
  get: function get() {
    return _SVBCTABlock.default;
  }
});
var _SVBCTABlock = _interopRequireDefault(require("./src/SVBCTABlock"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }